const sendingGift = state => state.app.sendingGift
const receivingGift = state => state.app.receivingGift
const getGiftSucceeded = state => state.app.getGiftSucceeded
const sendGiftSucceeded = state => state.app.sendGiftSucceeded
const receiveGiftSucceeded = state => state.app.receiveGiftSucceeded
const sendMailSucceeded = state => state.app.sendMailSucceeded
const inProgress = state => state.app.inProgress
const cancelGiftSucceeded = state => state.app.cancelGiftSucceeded
const notificationMessage = state => state.app.notificationMessage

export {
  sendingGift,
  receivingGift,
  getGiftSucceeded,
  sendGiftSucceeded,
  receiveGiftSucceeded,
  sendMailSucceeded,
  inProgress,
  cancelGiftSucceeded,
  notificationMessage
}



// WEBPACK FOOTER //
// ./src/store/Getters.js